import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button/button.jsx';

import styles from './community-button.css';
import schoolBadge from './school-badge.png';

const CommunityButton = ({
    className,
    onClick
}) => (
    <Button
        className={classNames(
            className,
            styles.communityButton
        )}
        onClick={onClick}
    >
        <span className={styles.communityContent}>
            <img
                alt=""
                className={styles.communityBadge}
                draggable={false}
                src={schoolBadge}
            />
            <span>查看作品页面</span>
        </span>
    </Button>
);

CommunityButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
};

CommunityButton.defaultProps = {
    onClick: () => {
        window.location.assign('/share/');
    }
};

export default CommunityButton;
